export const homeCarouselData = [
    {
        image: "/images/hero_images/our.jpg",
        path: "/seasonal_fruits/seasonal_produce",
        title: "FRESH FARM PRODUCE",
        subtitle: "Experience the taste of pure, organic goodness."
    },
    {
        image: "/images/hero_images/guava_farm.png",
        path: "/seasonal_fruits/seasonal_produce",
        title: "SEASONAL SUMMER FRUITS",
        subtitle: "Handpicked at peak ripeness for maximum flavor."
    },
    {
        image: "/images/hero_images/greenhouse.png",
        path: "/tropical_fruits/fresh_fruits",
        title: "TROPICAL DELIGHTS",
        subtitle: "Exotic fruits delivered fresh to your doorstep."
    }
]
